import { Injectable } from '@angular/core';
import { Icon, IconItem } from '@sb/library/base';
import { SocialMediaLinkType } from '@sb/library/data-models';

@Injectable({
    providedIn: 'root'
})
export class SocialMediaLinksManager {
    private _socialMediaIconMap: Record<SocialMediaLinkType, IconItem | null> = {
        [SocialMediaLinkType.Instagram]: Icon.Brand.InstagramOutlined,
        [SocialMediaLinkType.Facebook]: Icon.Brand.FacebookCircle,
        [SocialMediaLinkType.Twitter]: Icon.Brand.XCorp,
        [SocialMediaLinkType.LinkedIn]: Icon.Brand.Linkedin,
        [SocialMediaLinkType.YouTube]: Icon.Brand.Youtube,
        [SocialMediaLinkType.TikTok]: Icon.Brand.TikTok,
        [SocialMediaLinkType.Other]: Icon.Common.Language,
        [SocialMediaLinkType.Threads]: Icon.Brand.Threads,
        [SocialMediaLinkType.Bluesky]: Icon.Brand.Bluesky,
        [SocialMediaLinkType.Weibo]: Icon.Brand.Weibo,
        [SocialMediaLinkType.Bilibili]: Icon.Brand.Bilibili,
        [SocialMediaLinkType.Xiaohongshu]: Icon.Brand.Xiaohongshu
    };

    // generated by ai
    private _socialMediaDomainMap: Record<string, SocialMediaLinkType> = {
        // Instagram
        'instagram.com': SocialMediaLinkType.Instagram,

        // Facebook
        'facebook.com': SocialMediaLinkType.Facebook,
        'fb.com': SocialMediaLinkType.Facebook,
        'fb.me': SocialMediaLinkType.Facebook,

        // Twitter / X
        'twitter.com': SocialMediaLinkType.Twitter,
        'x.com': SocialMediaLinkType.Twitter,
        't.co': SocialMediaLinkType.Twitter,

        // LinkedIn
        'linkedin.com': SocialMediaLinkType.LinkedIn,

        // YouTube
        'youtube.com': SocialMediaLinkType.YouTube,
        'youtu.be': SocialMediaLinkType.YouTube,

        // TikTok
        'tiktok.com': SocialMediaLinkType.TikTok,
        'vm.tiktok.com': SocialMediaLinkType.TikTok,

        // Threads
        'threads.net': SocialMediaLinkType.Threads,
        'threads.com': SocialMediaLinkType.Threads,

        // Bluesky
        'bsky.app': SocialMediaLinkType.Bluesky,

        // Weibo
        'weibo.com': SocialMediaLinkType.Weibo,
        'weibo.cn': SocialMediaLinkType.Weibo,

        // Bilibili
        'bilibili.com': SocialMediaLinkType.Bilibili,
        'b23.tv': SocialMediaLinkType.Bilibili,

        // Xiaohongshu / Rednote
        'xiaohongshu.com': SocialMediaLinkType.Xiaohongshu,
        'xiaohongshu.cn': SocialMediaLinkType.Xiaohongshu,
        'xhslink.com': SocialMediaLinkType.Xiaohongshu,
        'rednote.com': SocialMediaLinkType.Xiaohongshu,
    };

    GetSocialMediaIcon(socialMediaType: SocialMediaLinkType): IconItem | null {
        return this._socialMediaIconMap[socialMediaType];
    }

    // robot generated code
    GetSocialMediaTypeFromUrl(url: string): SocialMediaLinkType {
        const s = url.toLowerCase().trim();
        const host = new URL(s).hostname.replace(/^www\./, '');
        for (const domain in this._socialMediaDomainMap) {
            if (host === domain || host.endsWith('.' + domain)) {
                return this._socialMediaDomainMap[domain];
            }
        }
        return SocialMediaLinkType.Other;
    }
}
